var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullscreenSquareExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21323_36385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94251 17.5C6.68118 17.5 6.46777 17.4129 6.30226 17.2387C6.13676 17.0645 6.05401 16.8554 6.05401 16.6115V13.946H3.3885C3.1446 13.946 2.93554 13.8589 2.76132 13.6847C2.58711 13.5105 2.5 13.3014 2.5 13.0575C2.5 12.7962 2.58711 12.5828 2.76132 12.4172C2.93554 12.2517 3.1446 12.169 3.3885 12.169H6.94251C7.18641 12.169 7.39547 12.2561 7.56969 12.4303C7.7439 12.6045 7.83101 12.8136 7.83101 13.0575V16.6115C7.83101 16.8554 7.7439 17.0645 7.56969 17.2387C7.39547 17.4129 7.18641 17.5 6.94251 17.5ZM3.3885 7.83101C3.1446 7.83101 2.93554 7.7439 2.76132 7.56969C2.58711 7.39547 2.5 7.18641 2.5 6.94251C2.5 6.68118 2.58711 6.46777 2.76132 6.30226C2.93554 6.13676 3.1446 6.05401 3.3885 6.05401H6.05401V3.3885C6.05401 3.1446 6.14112 2.93554 6.31533 2.76132C6.48955 2.58711 6.69861 2.5 6.94251 2.5C7.20383 2.5 7.41725 2.58711 7.58275 2.76132C7.74826 2.93554 7.83101 3.1446 7.83101 3.3885V6.94251C7.83101 7.18641 7.7439 7.39547 7.56969 7.56969C7.39547 7.7439 7.18641 7.83101 6.94251 7.83101H3.3885ZM13.0575 17.5C12.7962 17.5 12.5828 17.4129 12.4172 17.2387C12.2517 17.0645 12.169 16.8554 12.169 16.6115V13.0575C12.169 12.8136 12.2561 12.6045 12.4303 12.4303C12.6045 12.2561 12.8136 12.169 13.0575 12.169H16.6115C16.8554 12.169 17.0645 12.2561 17.2387 12.4303C17.4129 12.6045 17.5 12.8136 17.5 13.0575C17.5 13.3188 17.4129 13.5322 17.2387 13.6977C17.0645 13.8632 16.8554 13.946 16.6115 13.946H13.946V16.6115C13.946 16.8554 13.8589 17.0645 13.6847 17.2387C13.5105 17.4129 13.3014 17.5 13.0575 17.5ZM13.0575 7.83101C12.8136 7.83101 12.6045 7.7439 12.4303 7.56969C12.2561 7.39547 12.169 7.18641 12.169 6.94251V3.3885C12.169 3.1446 12.2561 2.93554 12.4303 2.76132C12.6045 2.58711 12.8136 2.5 13.0575 2.5C13.3188 2.5 13.5322 2.58711 13.6977 2.76132C13.8632 2.93554 13.946 3.1446 13.946 3.3885V6.05401H16.6115C16.8554 6.05401 17.0645 6.14112 17.2387 6.31533C17.4129 6.48955 17.5 6.69861 17.5 6.94251C17.5 7.20383 17.4129 7.41725 17.2387 7.58275C17.0645 7.74826 16.8554 7.83101 16.6115 7.83101H13.0575Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21323_36385",
    x: 1.5,
    y: 2.5,
    width: 17,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21323_36385"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21323_36385",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreenSquareExit);
export default __webpack_public_path__ + "static/media/icon-fullscreen-square-exit.920b1a6645c824b72fe5c586c2865faf.svg";
export { ForwardRef as ReactComponent };